import { Roles } from 'services/user-context/types';

export const canAccessPCodes = (roles: Roles | undefined) => {
  if (!roles) {
    return false;
  }
  const { PCodeFull, PCodeReadOnly } = roles;
  return PCodeFull || PCodeReadOnly;
};

export const canAccessCaseTypes = (roles: Roles | undefined) => {
  if (!roles) {
    return false;
  }
  const { CaseTypeReadOnly, CaseTypeFull } = roles;
  return CaseTypeReadOnly || CaseTypeFull;
};
